module.exports = __webpack_public_path__ + "img/logo_esic.ab127a8d.png";